'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import type { Address } from 'viem';
import { useDialogContext } from '@morpho-org/ui-v6/contexts';
import { Button } from '@repo/ui';
import { Close } from '@repo/ui/icons';
import { memo } from 'react';
import { ErrorServiceUnavailable } from '@/components/common/Error';
import SectionErrorBoundary from '@/components/common/SectionErrorBoundary';
import VaultV2PositionManagerWithdrawDialogContent from './VaultV2PositionManagerWithdrawDialogContent';
interface VaultV2PositionManagerWithdrawDialogProps {
  vaultAddress: Address;
  chainId: ChainId;
}
const VaultV2PositionManagerWithdrawDialog = t0 => {
  const $ = _c(13);
  const {
    vaultAddress,
    chainId
  } = t0;
  const {
    toggleDialog
  } = useDialogContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-title-sm">Withdraw</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== toggleDialog) {
    t2 = () => toggleDialog(false);
    $[1] = toggleDialog;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Close />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className="flex items-center justify-between gap-[16px]">{t1}<Button size="icon" onClick={t2} variant="secondary" aria-label="Close">{t3}</Button></div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ErrorServiceUnavailable minHeight="494px" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== chainId || $[8] !== vaultAddress) {
    t6 = <SectionErrorBoundary fallback={t5}><VaultV2PositionManagerWithdrawDialogContent vaultAddress={vaultAddress} chainId={chainId} /></SectionErrorBoundary>;
    $[7] = chainId;
    $[8] = vaultAddress;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className="gap-md flex flex-col dark:[--card:var(--accent)]" data-testid="vault-v2-withdraw-dialog">{t4}{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
export default memo(VaultV2PositionManagerWithdrawDialog);